var _rect, _rect2, _text, _text2, _rect3, _circle, _text3, _text4, _rect4, _circle2, _text5, _text6, _rect5, _circle3, _text7, _text8, _rect6, _circle4, _text9, _text0, _rect7, _text1, _rect8, _circle5, _text10, _text11, _text12, _rect9, _circle6, _text13, _text14, _text15, _rect0, _circle7, _text16, _text17, _text18, _rect1, _text19, _circle8, _path, _path2, _text20, _text21, _circle9, _text22, _circle0, _text23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreManagementControlCentreDashboardDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1180,
    height: 650,
    viewBox: "0 0 1180 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore desktop management control centre") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 650,
    rx: 32,
    fill: "#07152A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1178,
    height: 648,
    rx: 31,
    fill: "none",
    stroke: "#284260",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 46,
    fill: "#74BDFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 1.8
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    dy: 0
  }, "MANAGEMENT CONTROL CENTRE"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 87,
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    dy: 0
  }, "Fleet position"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 256,
    height: 112,
    rx: 20,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 145,
    r: 6,
    fill: "#087CFF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 192,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 850
  }, "48")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 91,
    y: 150,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.9
  }, "ACTIVE VEHICLES")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 115,
    width: 256,
    height: 112,
    rx: 20,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 145,
    r: 6,
    fill: "#30D6A1"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 343,
    y: 192,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 850
  }, "36")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 367,
    y: 150,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.9
  }, "SHIFTS TODAY")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 115,
    width: 256,
    height: 112,
    rx: 20,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 619,
    cy: 145,
    r: 6,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 619,
    y: 192,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 850
  }, "03")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 643,
    y: 150,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.9
  }, "OPEN REVIEWS")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 866,
    y: 115,
    width: 256,
    height: 112,
    rx: 20,
    fill: "#0A213D",
    stroke: "#284260"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 895,
    cy: 145,
    r: 6,
    fill: "#087CFF"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 895,
    y: 192,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 850
  }, "96%")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 919,
    y: 150,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.9
  }, "EVIDENCE COMPLETE")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 260,
    width: 710,
    height: 342,
    rx: 22,
    fill: "#0A213D",
    stroke: "#284260"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 298,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.2
  }, "RECENT OPERATIONAL EVENTS")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 321,
    width: 660,
    height: 64,
    rx: 14,
    fill: "#0F2847",
    stroke: "#284260"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 353,
    r: 7,
    fill: "#30D6A1"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 350,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20132047")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 370,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "Evidence complete")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 698,
    y: 358,
    fill: "#30D6A1",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "Shift active")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 400,
    width: 660,
    height: 64,
    rx: 14,
    fill: "#0F2847",
    stroke: "#284260"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 432,
    r: 7,
    fill: "#FF2775"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 429,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20131092")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 449,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "Variance surfaced")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 698,
    y: 437,
    fill: "#FF2775",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "Fuel review")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 479,
    width: 660,
    height: 64,
    rx: 14,
    fill: "#0F2847",
    stroke: "#284260"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 511,
    r: 7,
    fill: "#087CFF"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 508,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "FC\u20133188")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 528,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 650
  }, "No visible change")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 698,
    y: 516,
    fill: "#087CFF",
    textAnchor: "end",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "Checked out")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 772,
    y: 260,
    width: 370,
    height: 342,
    rx: 22,
    fill: "#0A213D",
    stroke: "#284260"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 801,
    y: 298,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: 1.2
  }, "REVIEWS BY TYPE")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 957,
    cy: 418,
    r: 90,
    fill: "none",
    stroke: "#203A58",
    strokeWidth: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M957 328a90 90 0 0 1 83 124",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1040 452a90 90 0 0 1-98 55",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 30,
    strokeLinecap: "round"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 957,
    y: 412,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 35,
    fontWeight: 850
  }, "03")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 957,
    y: 435,
    fill: "#AFC0D6",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 750
  }, "OPEN REVIEWS")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 560,
    r: 5,
    fill: "#087CFF"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 830,
    y: 564,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10
  }, "Fuel evidence")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 939,
    cy: 560,
    r: 5,
    fill: "#FF2775"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 953,
    y: 564,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10
  }, "Condition")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreManagementControlCentreDashboardDesktop);
export default __webpack_public_path__ + "static/media/fleetcore-management-control-centre-dashboard-desktop.879d4cd940423f41fa7335a0b2f31c60.svg";
export { ForwardRef as ReactComponent };